import { Link } from 'react-router-dom';

const values = [
  {
    icon: 'ri-shield-star-line',
    title: 'Sécurité',
    desc: 'Protocoles rigoureux pour la protection et l\'arrimage de vos colis, à chaque étape du voyage maritime.',
  },
  {
    icon: 'ri-team-line',
    title: 'Proximité',
    desc: 'Une équipe à l\'écoute et disponible localement, qui vous répond dans votre langue et votre fuseau horaire.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Transparence',
    desc: 'Tarifs clairs et détaillés, avec un mesurage précis du CBM et du tonnage. Aucune surprise à l\'arrivée.',
  },
];

export default function Values() {
  return (
    <section id="valeurs" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-10">
        <div className="grid lg:grid-cols-3 gap-10 lg:gap-16 items-start">
          <div className="lg:sticky lg:top-32">
            <span className="text-primary-600 text-sm font-semibold uppercase tracking-widest">Nos Valeurs</span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mt-3 leading-tight">
              Trois engagements qui guident chaque expédition
            </h2>
            <p className="mt-6 text-foreground-700 leading-relaxed">
              Chez Godwin Logistics, nous ne transportons pas seulement des conteneurs — nous portons la confiance de nos clients d'un continent à l'autre.
            </p>
            <Link to="/contact" className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-md bg-foreground-900 hover:bg-foreground-800 text-white text-sm font-semibold cursor-pointer whitespace-nowrap transition">
              Parlons de votre projet <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>

          <div className="lg:col-span-2 grid sm:grid-cols-1 gap-5">
            {values.map((v, i) => (
              <div key={i} className="p-6 md:p-8 rounded-lg bg-background-100 border border-background-200 flex gap-5 hover:bg-background-200/70 transition">
                <div className="w-14 h-14 flex items-center justify-center rounded-md bg-primary-500 text-white shrink-0">
                  <i className={`${v.icon} text-2xl`}></i>
                </div>
                <div>
                  <div className="flex items-center gap-3">
                    <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">{v.title}</h3>
                    <span className="text-xs text-foreground-500 font-mono">0{i + 1}</span>
                  </div>
                  <p className="mt-2 text-foreground-700 text-sm md:text-base leading-relaxed">{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}